module.exports = "https://cdn.realtymogul.com/static/media/img_compare.e9219f4f.jpg";